var React = require('react');

function IconMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m84 28c0 1.6484-1.3516 3-3 3h-62c-1.6484 0-3-1.3516-3-3v-4c0-1.6484 1.3516-3 3-3h62c1.6484 0 3 1.3516 3 3zm0 20c0-1.6484-1.3516-3-3-3h-62c-1.6484 0-3 1.3516-3 3v4c0 1.6484 1.3516 3 3 3h62c1.6484 0 3-1.3516 3-3zm0 24c0-1.6484-1.3516-3-3-3h-62c-1.6484 0-3 1.3516-3 3v4c0 1.6484 1.3516 3 3 3h62c1.6484 0 3-1.3516 3-3z"}));
}

IconMenu.defaultProps = {"width":"100pt","height":"100pt","version":"1.1","viewBox":"0 0 100 100"};

module.exports = IconMenu;

IconMenu.default = IconMenu;
